import { AiOutlineAntDesign } from "react-icons/ai";
import { RiReactjsFill } from "react-icons/ri";
import { MdOutlineMobileFriendly } from "react-icons/md";
import { BsBrowserFirefox } from "react-icons/bs";
import { CgPerformance } from "react-icons/cg";
import { HiChatAlt2 } from "react-icons/hi";
import {
  keyboarda,
  epoxy,
  sitechin,
  landingSitechin,
  defi,
  manageLanding,
  bookmark,
  easybank,
  secured,
  coffee,
  construction,
  cars,
  food,
  bootcamp,
  delivery,
  weekaway,
  clipboard,
  dentist,
  portfolio,
  user,
  thumbnailOne,
  thumbnailTwo,
  thumbnailThree,
  thumbnailFour,
  thumbnailFive,
  thumbnailSix,
  thumbnailSeven
} from "../assets";

// video list
import video1 from "../../src/assets/videos/one.mp4";
import video2 from "../../src/assets/videos/five.mp4";
import video3 from "../../src/assets/videos/two.mp4";
import video4 from "../../src/assets/videos/three.mp4";
import video5 from "../../src/assets/videos/four.mp4";
import video6 from "../../src/assets/videos/six.mp4";
import video7 from "../../src/assets/videos/seven.mov";

// NavLink Data
export const navLinksData = [
  {
    id: 1,
    title: "Home",
    path: "home",
  },
  {
    id: 2,
    title: "Features",
    path: "features",
  },
  {
    id: 3,
    title: "Projects",
    path: "projects",
  },
  {
    id: 4,
    title: "Resume",
    path: "resume",
  },
  {
    id: 5,
    title: "Testimonial",
    path: "testimonial",
  },
  {
    id: 6,
    title: "Contact",
    path: "contact",
  },
];

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <MdOutlineMobileFriendly />,
    title: "Responsive Web Design",
    desc: "Designing stunning websites that adapt flawlessly to all screen sizes, providing an exceptional user experience across desktop, tablet, and mobile devices.",
  },
  {
    id: 2,
    icon: <AiOutlineAntDesign />,
    title: "User Interface (UI) Development",
    desc: "Creating captivating user interfaces that blend intuitive design, compelling layouts, and engaging aesthetics, tailored to your brand and target audience.",
  },
  {
    id: 3,
    icon: <RiReactjsFill />,
    title: "Front-end Frameworks",
    desc: "Leveraging React and Next.js, I build advanced web apps with dynamic interactivity, superior performance, and seamless user experiences through server-side rendering.",
  },
  {
    id: 4,
    icon: <BsBrowserFirefox />,
    title: "Cross-Browser Compatibility",
    desc: "Achieving flawless cross-browser functionality by conducting thorough testing, troubleshooting compatibility issues, and improving accessibility for all users.",
  },
  {
    id: 5,
    icon: <CgPerformance />,
    title: "Performance Optimization",
    desc: "Supercharging website performance with optimized coding, file size reduction, image optimization, and advanced techniques for lightning-fast, user-centric experiences.",
  },
  {
    id: 6,
    icon: <HiChatAlt2 />,
    title: "Collaborative Approach",
    desc: "Enabling effective collaboration to understand project requirements, address technical constraints, and deliver quality front-end solutions within deadlines.",
  },
];

// Projects Data
export const projectsData = [
  {
    id: 1,
    img: cars,
    title: "maxwheels",
    githubLink: "https://github.com/imansaadat/car-website",
    demoLink: "https://imansaadat.github.io/car-website/",
    desc: "This is a modern, responsive car website built with HTML and Sass, designed to help you find your dream car.",
  },
  {
    id: 2,
    img: coffee,
    title: "coffee shop",
    githubLink: "https://github.com/imansaadat/react-coffee-shop",
    demoLink: "https://coffee-shop-cyan.vercel.app/",
    desc: " A Coffee Shop Website with React.js",
  },
  {
    id: 3,
    img: construction,
    title: "construction",
    githubLink: "https://github.com/imansaadat/Construction-website",
    demoLink: "https://imansaadat.github.io/Construction-website/",
    desc: "Modern construction website,built with HTML, Sass, JavaScript. Mobile-friendly and efficient.",
  },
  {
    id: 4,
    img: food,
    title: "food",
    githubLink: "https://github.com/imansaadat/food-website",
    demoLink: "https://imansaadat.github.io/food-website/",
    desc: "Delicious Bites: An Attractive, Responsive Food Website. Built with HTML, Sass, and JavaScript.",
  },
  {
    id: 5,
    img: bootcamp,
    title: "front end bootcamp",
    githubLink: "https://github.com/imansaadat/bootstrap-front-end-website",
    demoLink: "https://imansaadat.github.io/bootstrap-front-end-website/",
    desc: "An attractive front-end bootcamp website built with Bootstrap.",
  },
  {
    id: 6,
    img: delivery,
    title: "delivery",
    githubLink: "https://github.com/imansaadat/bootstrap-delivery-website",
    demoLink: "https://imansaadat.github.io/bootstrap-delivery-website/",
    desc: "A modern responsive delivery website built with Bootstrap.",
  },
  {
    id: 7,
    img: weekaway,
    title: "weekaway",
    githubLink: "https://github.com/imansaadat/Weekaway-website",
    demoLink: "https://imansaadat.github.io/Weekaway-website/public/",
    desc: "Weekaway Website: built with Tailwind CSS. Explore your dream getaway destinations with our modern and captivating travel platform.",
  },
  {
    id: 8,
    img: dentist,
    title: "dentalcare",
    githubLink: "https://github.com/imansaadat/dentist-react-tailwind",
    demoLink: "https://dentalcare-zeta.vercel.app/",
    desc: "A modern, responsive dentist website created with React.js",
  },
  {
    id: 9,
    img: clipboard,
    title: "clipboard",
    githubLink: "https://github.com/imansaadat/clipboard",
    demoLink: "https://imansaadat.github.io/clipboard/",
    desc: "A static and responsive website created with HTML, Sass, and Swiper.js",
  },
  {
    id: 10,
    img: epoxy,
    title: "epoxy",
    githubLink: "https://github.com/imansaadat/epoxy-project",
    demoLink: "https://imansaadat.github.io/epoxy-project/",
    desc: "Modern flooring website built with HTML, Sass, Bootstrap, and Swiper.js, presenting a captivating and responsive design",
  },
  {
    id: 11,
    img: secured,
    title: "secured",
    githubLink: "https://github.com/imansaadat/react-secured-website",
    demoLink: "https://secured-six.vercel.app/",
    desc: "An attractive and secure website built with React.js.",
  },
  {
    id: 12,
    img: bookmark,
    title: "bookmark",
    githubLink: "https://github.com/imansaadat/bookmark",
    demoLink: "https://imansaadat.github.io/bookmark/",
    desc: "A bookmark website that is mobile-friendly and built with HTML, Sass, and JavaScript.",
  },
  {
    id: 13,
    img: manageLanding,
    title: "manageLanding",
    githubLink: "https://github.com/imansaadat/manage-landing",
    demoLink: "https://imansaadat.github.io/manage-landing/",
    desc: "A visually stunning landing website created with HTML, Sass, and Swiper.js",
  },
  {
    id: 14,
    img: defi,
    title: "defi",
    githubLink: "https://github.com/imansaadat/defi-react-tailwind",
    demoLink: "https://defi-sigma.vercel.app/",
    desc: "A sleek and user-friendly Decentralized Trading Protocol website crafted with React.js and Tailwind CSS.",
  },
  {
    id: 15,
    img: easybank,
    title: "easybank",
    githubLink: "https://github.com/imansaadat/Easybank",
    demoLink: "https://imansaadat.github.io/Easybank/",
    desc: "A responsive website crafted with HTML, Sass, and JavaScript for an enhanced banking experience.",
  },
  {
    id: 16,
    img: portfolio,
    title: "portfolio",
    githubLink: "https://github.com/imansaadat/react-portfolio-tailwind",
    demoLink: "https://portfolio-phi-six-52.vercel.app/",
    desc: "A modern portfolio website using React.js and Tailwind CSS, delivering an eye-catching and responsive design",
  },
  {
    id: 17,
    img: landingSitechin,
    title: "landing sitechin",
    githubLink: "https://github.com/imansaadat/landing-sitechin",
    demoLink: "https://imansaadat.github.io/landing-sitechin/",
    desc: "An attractive and responsive landing page built with Bootstrap and custom JavaScript",
  },
  {
    id: 18,
    img: keyboarda,
    title: "keyboarda",
    githubLink: "https://github.com/imansaadat/next-keyboarda-website",
    demoLink: "https://next-keyboarda-website.vercel.app/",
    desc: "An awesome company website built with Next.js and Tailwind CSS, providing a responsive design that adapts beautifully to different screen sizes.",
  },
  {
    id: 19,
    img: sitechin,
    title: "sitechin",
    githubLink: "https://github.com/imansaadat/sitechin-project",
    demoLink: "https://sitechin.com/",
    desc: "An attractive, mobile-friendly website builder built with HTML, Sass, Bootstrap, and JavaScript for effortless creation of personal, corporate, and e-commerce websites.",
  },
];


// Experience Data
export const jobExperienceData = [
  {
    id: 1,
    title: "Front-end Developer ",
    subTitle: "Keyboarda group (2021 - Present)",
    location: "Tehran",
    desc: [
      "Performing front-end projects",
      "Developing websites and web pages",
      "Training and supervising interns' work",
    ],
  },
  {
    id: 2,
    title: "Front-end Developer ",
    subTitle: "Sitechin Company (2019 - 2021)",
    location: "Tehran",
    desc: [
      "Building an advanced website builder that can create",
      "Personal, corporate, or e-commerce websites for people in various job fields quickly",
      "Performing front-end projects with modern technologies",
      "Collaboration with UX/UI Team",
    ],
  },
  {
    id: 3,
    title: "Teacher and Freelancer",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    location: "Tehran",
    desc: [
      "Work as a freelancer (Front-end Developer)",
      "Part-time web programming teacher at an elementary school",
    ],
  },
];

// Education data
export const educationData = [
  {
    id: 1,
    title: "Currently Pursuing Bachelor's in Software Engineering",
    subTitle: "Islamic Azad University North Tehran Branch (2023 - Present)",
    location: "Tehran",
    desc: [
      "I am currently a student pursuing a Bachelor's degree in Software Engineering. My academic journey is focused on developing expertise in software development and computer science.",
    ],
  },
  {
    id: 2,
    title: "Bachelor of Biotechnology",
    subTitle: "Islamic Azad University of Parand Branch (2012 - 2016)",
    location: "Parand",
    desc: [
      "I have obtained a bachelor's degree in Biotechnology from the Islamic Azad University.",
    ],
  },
];

// trainer Experience Data
export const trainerExperienceData = [
  {
    id: 1,
    title: "Teacher",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    location: "Tehran",
    desc: ["Part-time web programming teacher at an elementary school"],
  },
];

// Certificate Data
export const courseraData = [
  {
    id: 1,
    title: "Learn to Program",
    subTitle: "Coursera (Nov 2022)",
    location: "University of Toronto",
    link: "https://www.coursera.org/account/accomplishments/certificate/F4CRTREBZYWP",
    desc: [
      "Introduction to programming and its importance.",
      "Gain the ability to write practical programs that have real-world applications.",
      "Fun and practical program development.",
    ],
  },
  {
    id: 2,
    title: "Responsive Web Design",
    subTitle: "Coursera (Mar 2022)",
    location: "University of London",
    link: "https://www.coursera.org/account/accomplishments/certificate/KAFHWCT3L4LJ",
    desc: [
      "The Importance of Responsive Design for Websites",
      "Creating Sites That Perform Well Across Different Platforms",
      "Mobile-First Paradigm and Wireframes in the Design Process",
      "Implementing Fluid Design and Media Queries",
    ],
  },
  {
    id: 3,
    title: "Advanced Styling with Responsive Design",
    subTitle: "Coursera (Apr 2022)",
    location: "University of Michigan",
    link: "https://www.coursera.org/account/accomplishments/certificate/6J9JJGVM8ZKC",
    desc: [
      "The importance of responsive design for websites.",
      "Creating sites that perform well across different platforms.",
      "Mobile-first paradigm and wireframes in the design process.",
      "Implementing fluid design and media queries",
      "Utilizing design frameworks like Bootstrap",
    ],
  },
  {
    id: 4,
    title: "Interactivity with JavaScript",
    subTitle: "Coursera (Dec 2021)",
    location: "University of Michigan",
    link: "https://www.coursera.org/account/accomplishments/certificate/E48TPK2AAVPE",
    desc: [
      "JavaScript basics for website interactivity.",
      "Working with variables, functions, and the DOM.",
      "Reacting to events and modifying webpage content.",
      "Creating an interactive HTML5 form.",
    ],
  },
  {
    id: 5,
    title: "HTML, CSS, and Javascript for Web Developers",
    subTitle: "Coursera (Oct 2021)",
    location: "Johns Hopkins University",
    link: "https://www.coursera.org/account/accomplishments/certificate/6UXHKE37J65Q",
    desc: [
      "HTML, CSS, and responsive web design mastery.",
      "Proficient in Javascript for dynamic web development.",
      "Integrated Ajax for enhanced functionality and user experience.",
    ],
  },
];

export const companiesData = [
  {
    id: 1,
    title: "Front-End Developer Capstone",
    subTitle: "Coursera (Aug 2023)",
    location: "Meta",
    link: "https://www.coursera.org/account/accomplishments/certificate/JRTF6YVLLYLH",
    desc: [
      "Design and style a responsive User Interface (UI)",
      "Use React components to create multiple views",
      "Demonstrate clean and bug free coding",
      "Create a website front-end using React JS and JavaScript",
    ],
  },
  {
    id: 2,
    title: "Advanced React",
    subTitle: "Coursera (Mar 2023)",
    location: "Meta",
    link: "https://www.coursera.org/account/accomplishments/certificate/VYQWEMAGJYNH",
    desc: [
      "Efficient rendering and state management in React.",
      "Fetching data from remote servers.",
      "Testing React components.",
      "Building a portfolio with React.",
    ],
  },
  {
    id: 3,
    title: "Version Control",
    subTitle: "Coursera (Jun 2023)",
    location: "Meta",
    link: "https://www.coursera.org/account/accomplishments/certificate/M3YQ745YMCRV",
    desc: [
      "Collaborate globally using version control.",
      "Optimize software development workflow.",
      "Automate tasks for productivity.",
      "Utilize Git for team file management and code revisions.",
    ],
  },
  {
    id: 4,
    title: "Programming with JavaScript",
    subTitle: "Coursera (Mar 2023)",
    location: "Meta",
    link: "https://www.coursera.org/account/accomplishments/certificate/C5D2P69U2TTG",
    desc: [
      "Basics of web development with JavaScript.",
      "Working with functions, objects, arrays, and variables.",
      "Manipulating the HTML DOM using JavaScript.",
      "Exploring interactive possibilities with JavaScript.",
    ],
  },
  {
    id: 5,
    title: "HTML and CSS in depth",
    subTitle: "Coursera (Nov 2022)",
    location: "Meta",
    link: "https://www.coursera.org/account/accomplishments/certificate/M3YQ745YMCRV",
    desc: [
      "Building web pages with HTML and structured data.",
      "Customizing styling with CSS.",
      "Creating responsive layouts using Bootstrap.",
      "Debugging and resolving front-end errors.",
    ],
  },
];

// Skills
export const designSkillsData = [
  {
    title: "User Interface design",
    percent: "80%",
  },
  {
    title: "Responsive design",
    percent: "85%",
  },
  {
    title: "FIGMA",
    percent: "50%",
  },
  {
    title: "ADOBE XD",
    percent: "50%",
  },
];

export const developmentSkillsData = [
  {
    title: "html 5",
    percent: "85%",
  },
  {
    title: "css3",
    percent: "80%",
  },
  {
    title: "Sass",
    percent: "80%",
  },
  {
    title: "bootstrap",
    percent: "85%",
  },
  {
    title: "tailwind",
    percent: "80%",
  },
  {
    title: "javascript",
    percent: "75%",
  },
  {
    title: "jquery",
    percent: "75%",
  },
  {
    title: "typescript",
    percent: "70%",
  },
  {
    title: "react",
    percent: "75%",
  },
  {
    title: "next js",
    percent: "70%",
  },
  {
    title: "git",
    percent: "80%",
  },
  {
    title: "github",
    percent: "85%",
  },
];

// Testimonial
export const testimonialData = [
  {
    id: 1,
    name: "Ahmad Reyhani",
    companyName: "The Signal Zone team",
    jobTitle: "The company manager",
    img: user,
    title: "Creating a modern Next.js website for the company",
    date: "September 11th, 2020",
    desc: "Collaborating with Mr. Saadat was one of the good experiences in Signal Zone. Expertise, accuracy, and responsiveness are among his characteristics.",
  },
  {
    id: 2,
    name: "Dr.adloo",
    companyName: "Parse",
    jobTitle: "Dentist",
    img: user,
    title: "Creating a dental website using React Js and Tailwind",
    date: "June 25th, 2022",
    desc: "I trusted him, and fortunately, I was amazed by his excellent performance in delivering the product on time and without any flaws.",
  },
  {
    id: 3,
    name: "Mohammad",
    companyName: "student",
    jobTitle: "HTML and Css learner",
    img: user,
    title: "Teaching HTML and CSS",
    date: "July 9th, 2022",
    desc: "The way Mr. Saadat expresses himself and his teaching method have helped me learn and understand the material much more easily than I had anticipated. It has made the process of grasping and memorizing the content much more effortless for me.",
  },
];

// FooterLinks
export const FooterLinksData = [
  {
    id: 1,
    title: "QUICK LINK",
    links: ["about", "Portfolio", "Services", "Blog", "Contact"],
  },
  {
    id: 2,
    title: "RESOURCES",
    links: [
      "Authentication",
      " System Status",
      "Terms of Service",
      " Pricing",
      " Over Right",
    ],
  },
  {
    id: 3,
    title: "DEVELOPERS",
    links: [
      "Documentation",
      "Authentication",
      "API Reference",
      "Support",
      " Open Source",
    ],
  },
];

// videoList
export const videoListData = [
  {
    title: "Teaching web programming (CSS Animation 1)",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    url: video1,
    thumbnail: thumbnailOne,
  },
  // as a Professor's Assistant
  {
    title: "Teaching Git and GitHub",
    subTitle: "Islamic Azad University, Tehran North Branch (2023)",
    url: video7,
    thumbnail: thumbnailSeven,
  },
  {
    title: "JavaScript (Function Expressions)",
    subTitle: "My Private Programming Class (2023)",
    url: video2,
    thumbnail: thumbnailFive,
  },
  {
    title: "JavaScript (For Loop)",
    subTitle: "My Private Programming Class (2023)",
    url: video6,
    thumbnail: thumbnailSix,
  },
  {
    title: "Teaching web programming (CSS Animation2)",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    url: video3,
    thumbnail: thumbnailTwo,
  },
  {
    title: "Teaching web programming (CSS Animation 3)",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    url: video4,
    thumbnail: thumbnailThree,
  },
  {
    title: "Front-end web development (HTML Headings)",
    subTitle: "Hedayat Elementary School (2018 - 2019)",
    url: video5,
    thumbnail: thumbnailFour,
  },
];
